import DashboardErrorPageIndex from "./container";

export default DashboardErrorPageIndex;
